import React, { useState } from "react";
import "./Genomic.css";
import data from "./Genomic.json";
import { cdnUrl } from "../../config/cdn";

const defaultTheme = {
    primary: "#0D746E",
    accent: "#00C4B8",
    light: "#28b0a0ff",
    dark: "#033B39",
};

const img = (file) => cdnUrl(file);

/* ================= HERO SECTION ================= */
const Hero = () => (
    <section
        className="g-hero"
        style={{ backgroundImage: `url(${img(data.hero.background)})` }}
    >
        <div className="overlay"></div>
        <div className="content">
            <h1 dangerouslySetInnerHTML={{ __html: data.hero.title }} />
        </div>
    </section>
);

/* ================= CONTACT POPUP ================= */
const ContactPopup = ({ open, onClose, pageName }) => {
    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        hospital: "",
        facilityType: "",
        query: "",
    });

    if (!open) return null;

    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch("http://localhost:5000/submit-form", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ pageName, ...formData }),
            });

            const result = await res.json();
            if (result.success) {
                setSubmitted(true);

                setTimeout(() => {
                    setSubmitted(false);
                    onClose();
                }, 2500);
            }
        } catch (error) {
            console.error("Form submission error:", error);
        }
    };

    return (
        <>
            <div className="modal-overlay">
                <div className="modal-box">
                    <h3>Contact Us</h3>

                    <form onSubmit={handleSubmit}>
                        <label>Name *</label>
                        <input name="name" required onChange={handleChange} />

                        <label>Email *</label>
                        <input type="email" name="email" required onChange={handleChange} />

                        <label>Phone</label>
                        <input name="phone" onChange={handleChange} />

                        <label>Hospital</label>
                        <input name="hospital" onChange={handleChange} />

                        <label>Healthcare Facility Type *</label>
                        <select name="facilityType" required onChange={handleChange}>
                            <option value="">Select a facility type</option>
                            <option>Hospital</option>
                            <option>Clinic</option>
                            <option>Diagnostic Lab</option>
                            <option>Specialty Center</option>
                        </select>

                        <label>Query</label>
                        <textarea name="query" rows={4} onChange={handleChange}></textarea>

                        <button type="submit" className="submit-btn">
                            {data.contactForm.submitButton}
                        </button>
                    </form>

                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>
            </div>

            {submitted && (
                <div className="success-popup">
                    {data.contactForm.successMessage}
                </div>
            )}
        </>
    );
};

/* ================= INTRO PANEL ================= */
const IntroPanel = ({ openPopup }) => (
    <section className="g-intro" style={{ backgroundColor: defaultTheme.primary }}>
        <div className="g-left-title">
            <h1>{data.introPanel.title}</h1>
        </div>

        <div className="g-intro-text">
            <p>{data.introPanel.content}</p>

            <button className="btn" onClick={openPopup}>{data.introPanel.buttonText}</button>
        </div>
    </section>
);

/* ================= SPECIALIZED UNDERSTANDING ================= */
const SpecializedUnderstanding = () => (
    <section className="g-two-column">
        <div className="left">
            <img
                src={img(data.specializedUnderstanding.image)}
                style={{ width: "100%", borderRadius: "20px" }}
                alt="Genomic Laboratory"
            />
        </div>

        <div className="right">
            <h2>{data.specializedUnderstanding.title}</h2>
            <p>{data.specializedUnderstanding.content}</p>

            <ul>
                {data.specializedUnderstanding.list.map((item, i) => (
                    <li key={i}>{item}</li>
                ))}
            </ul>
        </div>
    </section>
);

/* ================= BILLING WORKFLOW ================= */
const BillingWorkflow = () => (
    <section className="g-panel">
        <h2 className="section-heading">{data.workflow.title}</h2>

        <div className="workflow-grid">
            {data.workflow.steps.map((item, i) => (
                <div className="workflow-card" key={i}>
                    <h3 className="workflow-title">{item.title}</h3>
                    <p className="workflow-desc">{item.desc}</p>
                </div>
            ))}
        </div>
    </section>
);

/* ================= COMPLIANCE ================= */
const Compliance = () => (
    <section className="g-compliance">
        <img src={img(data.compliance.image)} alt="Compliance" />
        <div className="text">
            <h2>{data.compliance.title}</h2>
            <p>{data.compliance.content}</p>
        </div>
    </section>
);

/* ================= TECHNOLOGY INTEGRATION ================= */
const TechIntegration = () => (
    <section className="g-tech">
        <h2 className="g-tech-title">{data.techIntegration.title}</h2>
        <p className="g-tech-subtitle">{data.techIntegration.subtitle}</p>

        <div className="g-tech-grid">
            {data.techIntegration.points.map((item, i) => (
                <div key={i} className="g-tech-card">
                    {item}
                </div>
            ))}
        </div>
    </section>
);

/* ================= ANALYTICS ================= */
const AnalyticsReporting = () => (
    <section className="g-analytics">
        <h2>{data.analytics.title}</h2>
        <p>{data.analytics.content}</p>
    </section>
);

/* ================= MAIN PAGE ================= */
const Genomic = () => {
    const [openPopup, setOpenPopup] = useState(false);

    return (
        <div className="genomic-page">
            <Hero />
            <IntroPanel openPopup={() => setOpenPopup(true)} />
            <SpecializedUnderstanding />
            <BillingWorkflow />
            <Compliance />
            <TechIntegration />
            <AnalyticsReporting />

            <ContactPopup
                open={openPopup}
                onClose={() => setOpenPopup(false)}
                pageName="Genomic Page"
            />
        </div>
    );
};

export default Genomic;
